import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IQuantityMaxLimitInput {
	setQuantityMaxLimit: (value: number) => void;
	isDisabled: boolean;
}

const QuantityMaxLimitInput: React.FC<IQuantityMaxLimitInput> = ({ setQuantityMaxLimit, isDisabled }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldValue }) => ({
				validator(_, value) {
					if (getFieldValue('quantityRegulationRestaurants').length && !value) {
						return Promise.reject(new Error(t('enterMaxLimitOfQuantity')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t],
	);

	return (
		<FormInput
			testId="QuantityMaxLimitInput"
			name="quantityMaxLimit"
			label="maxLimitOfQuantityLabel"
			placeholder="Enter number from 1 to 100"
			type="number"
			onChangeNumber={(val) => setQuantityMaxLimit(val || 1)}
			disabled={isDisabled}
			validationRules={validationRules}
			min={1}
			max={100}
		/>
	);
};

export default React.memo(QuantityMaxLimitInput);
